import { useCallback, useEffect, useMemo } from 'react'
import { Layer, LineLayer, Source } from 'react-map-gl'
import { ITrajectories } from 'utils/interfaces'

const SumRouteOnMap = ({
  map,
  sumRouteLine,
  onRouteClicked,
}: {
  map?: mapboxgl.Map
  sumRouteLine: ITrajectories
  onRouteClicked: (coords: mapboxgl.LngLat) => void
}) => {
  const transferRouteStyle = useMemo<LineLayer>(() => {
    return {
      id: 'route-style',
      type: 'line',
      layout: {
        'line-cap': 'square',
      },
      paint: {
        'line-width': 7,
        'line-color': '#7077DF',
        'line-opacity': 1,
      },
    }
  }, [])

  const onMouseEnter = useCallback(
    (e: mapboxgl.MapMouseEvent) => {
      if (!map) {
        return
      }
      map.getCanvas().style.cursor = 'pointer'
    },
    [map]
  )

  const onMouseLeave = useCallback(() => {
    if (!map) {
      return
    }
    map.getCanvas().style.cursor = 'default'
  }, [map])

  const onMouseClick = useCallback(
    (e: mapboxgl.MapMouseEvent) => {
      if (!map) {
        return
      }
      onRouteClicked(e.lngLat)
    },
    [map, onRouteClicked]
  )

  useEffect(() => {
    if (!map) {
      return
    }
    map.on('mouseenter', 'route-style', onMouseEnter)
    map.on('mouseleave', 'route-style', onMouseLeave)
    map.on('click', 'route-style', onMouseClick)
    return () => {
      map.off('mouseenter', 'route-style', onMouseEnter)
      map.off('mouseleave', 'route-style', onMouseLeave)
      map.off('click', 'route-style', onMouseClick)
    }
  }, [map, onMouseEnter, onMouseLeave, onMouseClick])

  return (
    <>
      <Source id="sumrouteline" type="geojson" data={sumRouteLine}>
        <Layer {...transferRouteStyle} />
      </Source>
    </>
  )
}

export default SumRouteOnMap
